module.exports = __webpack_public_path__ + "static/praxis-66fcd794be21eccadbd7a78a022329f6.png";